interface FilterBarProps {
  keyword: string;
  onKeyword: (v: string) => void;
  type: string;
  onType: (v: string) => void;
  region: string;
  onRegion: (v: string) => void;
  year: string;
  onYear: (v: string) => void;
  sort: string;
  onSort: (v: string) => void;
  typeOptions: string[];
  regionOptions: string[];
  yearOptions: string[];
  onReset: () => void;
}

interface FilterGroupProps {
  label: string;
  value: string;
  options: string[];
  onChange: (v: string) => void;
}

function FilterGroup({ label, value, options, onChange }: FilterGroupProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2">
      <span className="text-xs font-medium text-foreground-500 sm:w-20 shrink-0">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt}
            type="button"
            onClick={() => onChange(opt)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
              value === opt
                ? "bg-accent-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-secondary-100"
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterBar({
  keyword,
  onKeyword,
  type,
  onType,
  region,
  onRegion,
  year,
  onYear,
  sort,
  onSort,
  typeOptions,
  regionOptions,
  yearOptions,
  onReset,
}: FilterBarProps) {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200/80 p-4 md:p-5 space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-center gap-2">
        <span className="text-xs font-medium text-foreground-500 sm:w-20 shrink-0">关键词</span>
        <div className="relative flex-1">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          <input
            type="text"
            value={keyword}
            onChange={(e) => onKeyword(e.target.value)}
            placeholder="输入主播名称或关键词"
            className="w-full h-10 pl-9 pr-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-accent-400 transition-colors"
          />
        </div>
      </div>

      <FilterGroup label="主播类型" value={type} options={typeOptions} onChange={onType} />
      <FilterGroup label="所在地区" value={region} options={regionOptions} onChange={onRegion} />
      <FilterGroup label="活跃年份" value={year} options={yearOptions} onChange={onYear} />

      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 pt-3 border-t border-background-200/70">
        <div className="flex items-center gap-2">
          <span className="text-xs font-medium text-foreground-500">排序</span>
          <div className="flex gap-1 p-1 rounded-full bg-background-100">
            {[
              { key: "latest", label: "最新" },
              { key: "hot", label: "最热" },
            ].map((s) => (
              <button
                key={s.key}
                type="button"
                onClick={() => onSort(s.key)}
                className={`px-4 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  sort === s.key ? "bg-primary-600 text-background-50" : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {s.label}
              </button>
            ))}
          </div>
        </div>
        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center gap-1 text-xs text-foreground-500 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-refresh-line"></i>
          重置筛选
        </button>
      </div>
    </div>
  );
}